import { container, title, description, mrAuto, mlAuto } from 'assets/jss/material-kit-pro-react.js';
import imagesStyles from 'assets/jss/material-kit-pro-react/imagesStyles.js';

const imgRaised = imagesStyles.imgRaised;
const rounded = imagesStyles.imgRounded;
const imgFluid = imagesStyles.imgFluid;

const servicesStyle = {
  container,
  title: {
    ...title,
    color: 'white',
  },
  description,
  mrAuto,
  mlAuto,
  textCenter: {
    textAlign: 'center',
  },
  office: {
    padding: '80px 0',
    '& img': {
      margin: '20px 0px',
    },
  },
  imgRaised,
  rounded,
  imgFluid,
};

export default servicesStyle;
